// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".media-library-asset--Yci76{border:3px solid rgba(0,0,0,0)}.media-library-asset--Yci76.selected--reY0P{border:3px solid #5645f5}.media-library-asset--Yci76 .asset-name--xJXPq{height:22px;line-height:22px;max-width:70%;color:#fff;background-color:rgba(36,40,47,.6);border-radius:2px}.media-library-asset--Yci76.media-library-audio-asset--dl3nL{border:3px solid rgba(0,0,0,0);border-radius:8px;cursor:pointer}.media-library-asset--Yci76.media-library-audio-asset--dl3nL.selected--reY0P{border-color:#5645f5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"media-library-asset": "media-library-asset--Yci76",
	"selected": "selected--reY0P",
	"asset-name": "asset-name--xJXPq",
	"media-library-audio-asset": "media-library-audio-asset--dl3nL"
};
export default ___CSS_LOADER_EXPORT___;
